import script from "./OAuthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthPage.vue?vue&type=script&setup=true&lang=js"

import "./OAuthPage.vue?vue&type=style&index=0&id=2daba630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2daba630"]])

export default __exports__